import axios from '@/plugin/axios';
import Routes from './routes';

export const getProgramAreas = async () => {
  const response = await axios.get(Routes.program_areas, {
    params: {
      page: 1,
      size: 1000,
    },
  });

  return response.data;
};

export const createProgramArea = async (payload) => {
  const response = await axios.post(Routes.program_areas, payload);
  return response.data;
};

export const updateProgramArea = async (id, payload) => {
  const response = await axios.put(`${Routes.program_areas}${id}/`, payload);
  return response.data;
};

export const deleteProgramArea = async (id) => {
  const response = await axios.delete(`${Routes.program_areas}${id}/`);
  return response.data;
};
